<p-blockUI [blocked]="blocked">
    <i class="pi pi-lock" style="font-size: 4rem"></i>
</p-blockUI>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>

<div class="card">
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
                (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>
    <div class="p-col-12">
        <div class="p-md-6 ">
            <div class="card view">
                <div class="p-fluid">
                    <!-- Input Zone-->
                    <div class="p-col-12 p-m-2">
                        <div class=" p-fluid p-formgrid p-grid church_field">
                            <div class="p-col-12 p-md-2 church_field--label">
                                <label for="opt">{{translations.lbl_zone}}</label>
                            </div>
                            <div class="p-col-12 p-md-10">
                                <p-dropdown [options]="listZones" [(ngModel)]="selectedZone" optionLabel="descri"
                                    [showClear]="false" placeholder="{{translations.lbl_select}} {{translations.lbl_zone}}"
                                    (onChange)="loadNatios($event)"></p-dropdown>
                            </div>

                            <div class="p-col-12 p-md-10">

                            </div>



                        </div>
                    </div>

                    <!-- Input Natio-->
                    <div class="p-col-12 p-m-2">
                        <div class=" p-fluid p-formgrid p-grid church_field">
                            <div class="p-col-12 p-md-2 church_field--label">
                                <label for="opt">{{translations.lbl_national}}</label>
                            </div>
                            <div class="p-col-12 p-md-10">
                                <p-dropdown [options]="listNatio" [(ngModel)]="selectedNatio" optionLabel="descri"
                                    [showClear]="true" placeholder="{{translations.lbl_select}} {{translations.lbl_national}}"
                                    (onChange)="loadLocals($event)"></p-dropdown>
                            </div>
                        </div>
                    </div>

                    <!-- Input Local -->
                    <div class="p-col-12 p-m-2">
                        <div class=" p-fluid p-formgrid p-grid church_field">
                            <div class="p-col-12 p-md-2 church_field--label">
                                <label for="opt">{{translations.lbl_local}}</label>
                            </div>
                            <div class="p-col-12 p-md-10">
                                <p-dropdown [virtualScroll]="true" [options]="listLocal" [(ngModel)]="selectedLocal"
                                    itemSize="30" optionLabel="descri" [showClear]="true"
                                    placeholder="{{translations.lbl_select}} {{translations.lbl_local}}"></p-dropdown>
                            </div>
                        </div>
                    </div>

                    <div class="p-col-12 p-m-2">
                        <div class=" p-fluid p-formgrid p-grid church_field">
                            <div class="p-col-12 p-md-8"></div>
                            <div class="p-col-12 p-md-4">
                                <div class="ui-float-label">
                                    <button type="button" pButton pRipple icon="pi pi-search-plus" class="p-mr-4 z-5"
                                        pTooltip="test" tooltipPosition="bottom" label="{{translations.lbl_search}}"
                                        (keyup.enter)="loadRecords($event)" (click)="loadRecords($event)"></button>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="p-md-12 ">
            <p-table #dt [value]="lstItems" [rows]="10" [paginator]="true"
                [globalFilterFields]="['guidefullName','itemDescr','guideEmail']" [(selection)]="selectedChurch"
                [rowHover]="true" dataKey="wrksId"
                currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}"
                [showCurrentPageReport]="true" styleClass="p-datatable-responsive-demo">

                <ng-template pTemplate="caption" class="p-col-12 p-m-2">
                    <h5 class="church--title ">{{translations.lbl_consult}} {{translations.lbl_audios}} {{translations.lbl_and}} {{translations.lbl_videos}} {{translations.lbl_non_existent}} {{translations.lbl_in}} {{translations.lbl_cxc}} 3</h5>
                    <div class="p-fluid p-formgrid p-grid">
                        <!-- Input City-->
                        <div class="p-col-12 mb-2">
                            <div class=" p-fluid p-formgrid p-grid church_field">
                                <div class="p-col-12 p-md-6 church_field--label church_field--buttons"> 
                                    <button *ngIf="isPropertyActive" type="button" pButton pRipple icon="pi pi-plus" (click)="openNewChurch()"
                                        class="p-mr-4 z-5" pTooltip="{{lbl_new_record}}"
                                        tooltipPosition="bottom"></button>

                                    <button *ngIf="isMongoDisabled" type="button" pButton pRipple icon="pi pi-file-excel"
                                        (click)="exportExcel()" class="p-button-success p-mr-2 z-5" pTooltip="XLS"
                                        tooltipPosition="bottom"></button> 
                                    <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                                        class="p-button-warning p-mr-2" pTooltip="PDF"
                                        tooltipPosition="bottom"></button>
                                </div>
                                <div class="p-col-12 p-md-4">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input pInputText type="text"
                                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                                            placeholder="{{translations.lbl_search}}..." />
                                    </span>
                                </div>
                            </div>
                        </div>

                    </div>
                </ng-template>

                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="guidefullName">{{translations.lbl_name}}<p-sortIcon field="guidefullName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="itemDescr">{{translations.lbl_item}} <p-sortIcon field="itemDescr"></p-sortIcon></th>
                        <th pSortableColumn="guideEmail">{{translations.lbl_language}} <p-sortIcon field="guideEmail"></p-sortIcon>
                        </th>
                        <th pSortableColumn="language">{{translations.lbl_email}}<p-sortIcon field="language"></p-sortIcon></th>
                        <th pSortableColumn="purchItmDwn.purchDate">{{translations.lbl_order_date}}<p-sortIcon
                                field="purchItmDwn.purchDate"></p-sortIcon></th>
                        <!-- <th pSortableColumn="purchItmDwn.endDate">{{translations.lbl_ending_date}}<p-sortIcon
                                field="purchItmDwn.endDate"></p-sortIcon></th> -->
                        <th pSortableColumn="status">{{translations.lbl_status}}<p-sortIcon field="status"></p-sortIcon></th>
                        <th>{{translations.lbl_actions}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-itm>
                    <tr>
                        <td>{{itm.guidefullName}}</td>
                        <td style="white-space: normal; word-wrap: break-word;">{{itm.itemDescr}} </td>
                        <td>{{itm.purchItmDwn.id.language}}</td>
                        <td style="white-space: normal; word-wrap: break-word;">{{itm.guideEmail}}</td>
                        <td>{{formatDate(itm.purchItmDwn.purchDate)}}</td>
                        <!-- <td>{{formatDate(itm.purchItmDwn.endDate)}}</td> -->
                        <td>{{itm.prchStatusDesc}}</td>
                        <td>

                            <!--button pButton *ngIf="workshop.status=='C'"  pRipple icon="pi pi-search" class="p-button-rounded p-button-secondary p-mr-2" (click)="openChurchDetail(workshop)" pTooltip="{{lbl_select}}"></button -->
                            <button *ngIf="!itm.prchStatusDesc.includes('CXC')" pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger"
                                (click)="deleteRecord(itm)" pTooltip="{{translations.lbl_delete_record}}"
                               ></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{translations.lbl_total}} {{lstItems ? lstItems.length : 0 }} {{translations.lbl_records}}.
                    </div>
                </ng-template>
            </p-table>
        </div>


    </div>

    <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>